export function getRandNum(num) {
  const rand = Math.random() * num;
  return rand;
}

export function getRandNumMp(num) {
  const mp = ['-', ''];
  const _mp = mp[Math.floor(Math.random() * mp.length)];
  const rand = Math.random() * num;
  return _mp+rand;
}

export function getRandNumPlus(num) {
  const rand = Math.random() * num;
  return rand;
}

// この関数は、指定された最小値(min)と最大値(max)の範囲で整数のランダムな数を生成し、その数を返します。
// Math.random()は0以上1未満のランダムな数を生成するので、この数を(max - min + 1)で乗算し、Math.floorで整数に変換し、最後に最小値(min)を加えて範囲を調整しています。
export function intRandom(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// この関数は、最小値と最大値（0以下および小数点付きの数値も含む）の間でランダムな数を生成し、指定された小数点以下の桁数でその数を切り捨てます。
// 使用例:
// 最小値 -5.5、最大値 10.2、小数点以下3桁でランダムな数を生成
// const randomNumber = customRandom(-5.5, 10.2, 3);
export function customRandom(min, max, decimalPlaces) {
  if (min > max) {
    throw new Error("最小値は最大値より小さくなければなりません。");
  }
  const rand = Math.random() * (max - min) + min;
  return parseFloat(rand.toFixed(decimalPlaces));
}